
import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-home',
  templateUrl: './login-home.component.html',
  styleUrls: ['./login-home.component.css']
})
export class LoginHomeComponent {
  imagen: string = "/assets/images/Group-22101.png";
  token: string = "";

  constructor(
    private router: Router,
    private _ngZone: NgZone) { }

  login() {
    this._ngZone.run(() => {
      this.router.navigate(['/home']);
    });
  }
}
